// extracted by mini-css-extract-plugin
module.exports = {"section":"certifications_section__BRGg6","wrapper":"certifications_wrapper__2-0Uq","item":"certifications_item__3pjXs"};